export const fmtMoney = (n) =>
  (n >= 0 ? "" : "-") + "€" + Math.abs(Number(n || 0)).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtSigned = (n) =>
  (n >= 0 ? "+" : "-") + "€" + Math.abs(Number(n || 0)).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtPct = (n) => (n >= 0 ? "+" : "") + Number(n || 0).toFixed(2) + "%";

export const pnlColor = (n) => (n > 0 ? "text-[#10B981]" : n < 0 ? "text-[#EF4444]" : "text-[#9CA3AF]");

export const confColor = (c) => (c >= 80 ? "#10B981" : c >= 65 ? "#FACC15" : "#F59E0B");

export const regimeColor = (r) => ({
  "TRENDING": "#10B981", "HIGH VOLATILITY": "#EF4444",
  "LOW VOLATILITY": "#3B82F6", "RANGING": "#F59E0B",
}[r] || "#9CA3AF");
